// extracted by mini-css-extract-plugin
export default {"title":"Haa-z","warning":"Iaa-z","sizeOptionsLegendText":"Jaa-z"};